import React from 'react';
import { Route, Switch } from 'react-router-dom';
import KpiConfigAppWrapper from './pages/KpiConfig/AppWrapper';
import Notifications from './pages/notifications/AppWrapper';
import './less/configurationApp.less';
import '../../i18n';

export default function ConfigurationAppWrapper() {
    return (
        <Switch>
            <Route
                path="/Configuration/kpiConfig"
                component={KpiConfigAppWrapper}
            />
            <Route
                path="/Configuration/notifications"
                component={Notifications}
            />
        </Switch>
    );
}
